import React from 'react';
import {Route} from 'react-router-dom';
import Async from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route key="/business/impressum" element={<DefaultBusinessLayout />}>
    <Route path="business/impressum" element={<Async />} />
  </Route>
);
